<template>
  <div>
    <el-card>
      <div>
        <el-button size="small" type="primary" @click="submit">保存</el-button>
        <el-button size="small" @click="cancel">取消</el-button>
      </div>
      <el-form ref="formRef" :model="openForm" :rules="rule" class="FormCl" label-width="120px">
        <el-form-item label="RFID：" prop="rfid_no" size="small">
          <el-input ref="cardRef" v-model="openForm.rfid_no" :disabled="openForm.rfid_no.length == 10">
            <template slot="append">
              <el-link class="vg_pointer" type="primary" @click="emptyChange">清空</el-link>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="样品编号：" prop="samp" size="small">
          <el-input v-model="openForm.samp" :disabled="true" placeholder="请选择样品编号">
            <template slot="append">
              <el-link class="vg_pointer" type="primary" @click="openSampDialog()">选择</el-link>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="委托单号：" prop="entr" size="small">
          <el-input v-model="openForm.entr" disabled placeholder="请选择委托单号"> </el-input>
        </el-form-item>
        <el-form-item label="样品数量：" prop="smpl_num" size="small">
          <el-input v-model="openForm.smpl_num" disabled placeholder="样品数量"> </el-input>
        </el-form-item>
        <el-form-item label="所属部门：" prop="belo_dept_name" required size="small">
          <el-input v-model="openForm.belo_dept_name" disabled placeholder="请选择所属部门"> </el-input>
        </el-form-item>
        <el-form-item label="开卡人姓名:" prop="stff_name" size="small">
          <el-input v-model="openForm.stff_name" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="开板分数:" prop="open_fraction" size="small">
          <el-input
            v-model="openForm.open_fraction"
            maxLength="3"
            @input="value => (openForm.open_fraction = keepNDecimal(value, 1))"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否需要经历：">
          <div style="display: flex; flex-direction: column">
            <el-row>
              <el-col v-for="item in processList" :key="item.key" :md="12" style="display: flex; align-items: center; margin-bottom: 6px">
                <el-checkbox v-model="openForm[item.key]" :disabled="item.disabled">
                  {{ item.label }}
                </el-checkbox>
                <div v-if="openForm[item.key]" class="vg_ml_8">
                  难度系数:
                  <el-input-number
                    v-model="openForm[item.diffKey]"
                    :max="100"
                    :min="1.0"
                    :precision="1"
                    :step="0.5"
                    class="vg_ml_8"
                    size="mini"
                  />
                </div>
              </el-col>
            </el-row>
          </div>
        </el-form-item>
      </el-form>
    </el-card>
    <!-- 样品编号 -->
    <el-dialog :visible.sync="dialogSampVisible" title="样品信息列表(未开卡)" width="70%">
      <template>
        <el-form ref="form" :model="searchSampForm" label-width="100px">
          <el-row>
            <el-col :md="8">
              <el-form-item label="样品编号：">
                <el-input v-model="searchSampForm.smpl_no" clearable placeholder="请输入样品编号" size="small"></el-input>
              </el-form-item>
            </el-col>
            <el-col :md="8">
              <el-form-item label="样品名称：">
                <el-input v-model="searchSampForm.smpl_name" clearable placeholder="请输入样品名称" size="small"></el-input>
              </el-form-item>
            </el-col>
            <el-col :md="8">
              <el-form-item label="所属部门:">
                <selectSectionType ref="selectSectionType" @selectStatusRow="getStatusVal2" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="vg_mb_16">
            <el-col :md="8">
              <el-button class="vg_ml_16" size="small" type="primary" @click="searchSamp">搜索</el-button>
              <el-button class="vg_mr_8" size="small" type="info" @click="searchSampO">刷新</el-button>
              <el-link class="vg_cursor" type="primary" @click="gosmpl"><i class="el-icon-edit-outline"></i>样品总控表管理</el-link>
            </el-col>
          </el-row>
          <div class="vg_mb_8"><i class="el-icon-info vg_mr_8"></i>{{ title }}</div>
          <el-table v-loading="loadingFlag" :data="SampList" border class="vg_pointer" style="width: 100%" @cell-dblclick="sampDbClick">
            <el-table-column align="center" label="序号" type="index"></el-table-column>
            <el-table-column label="样品编号" prop="smpl_no"> </el-table-column>
            <el-table-column label="客户货号" prop="smpl_cust_no">
              <template slot-scope="scope">
                <span v-if="scope.row.smpl_cust_no">{{ scope.row.smpl_cust_no }}</span>
                <span v-else class="vg_9f9a9a">暂无</span>
              </template>
            </el-table-column>
            <el-table-column label="委托编号" prop="requ_no"></el-table-column>
            <el-table-column label="更改号" prop="smpl_suffix"></el-table-column>
            <el-table-column label="样品名称" prop="smpl_name"> </el-table-column>
            <el-table-column :formatter="formatSmplType" label="样品类型" prop="smpl_type"> </el-table-column>
            <el-table-column label="样品数量" prop="smpl_num">
              <template slot-scope="scope">
                <span v-if="scope.row.smpl_num || scope.row.smpl_num === 0">{{ scope.row.smpl_num | formatSmplNum }}</span>
                <span v-else class="vg_9f9a9a">暂无</span>
              </template>
            </el-table-column>
            <el-table-column label="样品间报价" prop="smpl_price">
              <template slot-scope="scope">
                <span v-if="scope.row.smpl_price">{{ scope.row.smpl_price | foamatSmplPrice }}</span>
                <span v-else class="vg_9f9a9a">暂无</span>
              </template>
            </el-table-column>
            <el-table-column label="采购部核价" prop="smpl_verify_price">
              <template slot-scope="scope">
                <span v-if="scope.row.smpl_verify_price">{{ scope.row.smpl_verify_price | formatSmplVerifyPrice }}</span>
                <span v-else class="vg_9f9a9a">暂无</span>
              </template>
            </el-table-column>
            <el-table-column label="所属部门" prop="belo_dept_name"></el-table-column>
            <el-table-column :formatter="formatDate" label="创建时间" prop="create_time" />
          </el-table>
          <pubPagination ref="pubPagination" :totalPage="SampTotal" @changePageSearch="changeSampPageSearch"></pubPagination>
        </el-form>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { get, post } from '@api/request';
import { smplAPI } from '@api/modules/smpl'; //getSmpls
import { rfidAPI } from '@api/modules/rfid'; //rfid
import pubPagination from '@/components/common/pubPagination';
import selectSectionType from '@/views/component/selectSectionType';
import helper from '@assets/js/helper.js';
import { keep2Decimal, keepNDecimal, keepNumber } from '@assets/js/regExUtil';
import { cloneDeep } from 'lodash';

export default {
  name: 'openCard',
  components: {
    pubPagination,
    selectSectionType
  },
  mounted() {
    this.$refs.cardRef.focus();
  },
  created() {
    this.getDepartment();
    this.getUserInof();
    this.getSampList();
  },
  data() {
    return {
      openForm: {
        rfid_no: '',
        samp: '', //显示
        entr: '', //显示
        smpl_id: '', //样品编号id
        requ_id: '', //委托编号id

        stff_id: '', //开卡人id
        stff_name: '', //开卡人姓名
        user_id: '', //开卡人id
        stpr_status: true,
        comp_status: true,
        stam_status: true,
        embr_status: true,
        mase_status: true,
        lase_status: true,
        handCut_status: true,
        manu_status: true,
        insp_status: true,
        open_status: true,
        emcd_status: true,
        typesetting_status: true,
        belo_dept_id: null,
        belo_dept_name: null,
        open_fraction: 0.5,
        open_difficulty_coefficient: 1.0,
        stpr_difficulty_coefficient: 1.0,
        comp_difficulty_coefficient: 1.0,
        lase_difficulty_coefficient: 1.0,
        stam_difficulty_coefficient: 1.0,
        embr_difficulty_coefficient: 1.0,
        emcd_difficulty_coefficient: 1.0,
        mase_difficulty_coefficient: 1.0,
        manu_difficulty_coefficient: 1.0,
        insp_difficulty_coefficient: 1.0,
        handCut_difficulty_coefficient: 1.0,
        typesetting_difficulty_coefficient: 1.0
      },
      rule: {
        rfid_no: [{ required: true, trigger: 'blur', message: ' ' }],
        samp: [{ required: true, trigger: 'blur', message: ' ' }],
        entr: [{ required: true, trigger: 'blur', message: ' ' }],
        stff_id: [{ required: true, trigger: 'blur', message: ' ' }],
        stff_name: [{ required: true, trigger: 'blur', message: ' ' }]
      },
      dialogSampVisible: false,
      SampList: [], //样品
      SampTotal: 0,
      title: ' 提示：(双击表编对应数据即可选中人员)',
      searchSampForm: {
        page_no: 1,
        smpl_no: null,
        smpl_name: null,
        belo_dept_id: null,
        isDyj: true,
        beloDeptId: null
      },
      loadingFlag: true,
      selectRefuDisabled: false,
      processList: [
        { key: 'open_status', label: '开版', diffKey: 'open_difficulty_coefficient' },
        { key: 'typesetting_status', label: '排版', diffKey: 'typesetting_difficulty_coefficient' },
        { key: 'stpr_status', label: '备料', diffKey: 'stpr_difficulty_coefficient' },
        { key: 'comp_status', label: '复合', diffKey: 'comp_difficulty_coefficient' },
        { key: 'lase_status', label: '激光', diffKey: 'lase_difficulty_coefficient' },
        { key: 'stam_status', label: '印花', diffKey: 'stam_difficulty_coefficient' },
        { key: 'embr_status', label: '电绣', diffKey: 'embr_difficulty_coefficient' },
        { key: 'emcd_status', label: '制卡', diffKey: 'emcd_difficulty_coefficient' },
        { key: 'mase_status', label: '机缝', diffKey: 'mase_difficulty_coefficient' },
        { key: 'manu_status', label: '手工', diffKey: 'manu_difficulty_coefficient' },
        { key: 'insp_status', label: '检验', diffKey: 'insp_difficulty_coefficient', disabled: true },
        { key: 'handCut_status', label: '手裁', diffKey: 'handCut_difficulty_coefficient' }
      ]
    };
  },
  filters: {
    foamatSmplPrice(row) {
      return helper.haveFour(row);
    },
    formatSmplVerifyPrice(row) {
      return helper.haveFour(row);
    },
    formatSmplNum(row) {
      return helper.haveFour(row);
    }
  },
  methods: {
    keepNDecimal,
    keepNumber,
    keep2Decimal,
    //获取打样部门
    getDepartment() {
      let userInfo = this.$cookies.get('userInfo');
      if (userInfo.dept_id === 2 || userInfo.dept_id === 17) {
        this.searchSampForm.belo_dept_id = userInfo.dept_id + '';
        this.beloDeptId = userInfo.dept_id + '';
        this.isDyj = true;
      } else {
        this.searchSampForm.belo_dept_id = null;
        this.isDyj = false;
      }
    },
    //获取样品数据
    getSampList() {
      get(smplAPI.get_all_smpls_v1, this.searchSampForm)
        .then(res => {
          if (res.data.code !== 0) {
            return console.log('数据请求失败');
          }
          this.SampList = res.data.data.list;
          this.SampTotal = res.data.data.total;
          setTimeout(() => {
            this.loadingFlag = false;
          }, 300);
        })
        .catch(res => {
          let mg = res.data.msg;
          let tp = 'error';
          this.$message({ message: mg, type: tp });
        });
    },
    // 时间转换
    formatDate(row) {
      return this.helper.toStringDate(row.create_time);
    },
    //从cookie中获取信息
    getUserInof() {
      let info = this.$cookies.get('userInfo');
      this.openForm.stff_id = info.stff_id;
      this.openForm.stff_name = info.stff_name;
      this.openForm.user_id = info.user_id;
    },
    //选择 样品编号
    openSampDialog() {
      this.dialogSampVisible = true;
    },
    openEntrDialog() {
      this.dialogEntrVisible = true;
    },
    // 样品类型判断
    formatSmplType(row) {
      if (row.smpl_type === 1) {
        return '新款';
      } else if (row.smpl_type === 2) {
        return '老款';
      } else if (row.smpl_type === 3) {
        return '修改款';
      }
    },
    //样品 双击获取数据
    sampDbClick(val) {
      this.openForm.smpl_id = val.smpl_id;
      this.openForm.samp = val.smpl_no;
      this.openForm.entr = val.requ_no;
      this.openForm.smpl_num = val.smpl_num;
      this.openForm.requ_id = val.requ_id;
      this.openForm.belo_dept_id = val.belo_dept_id;
      this.openForm.belo_dept_name = val.belo_dept_name;

      this.dialogSampVisible = false;
    },
    changeSampPageSearch(val) {
      this.searchSampForm.page_no = val;
      this.getSampList();
    },
    searchSamp() {
      this.loadingFlag = true;
      this.searchSampForm.page_no = 1;
      this.getSampList();
    },
    // 刷新
    searchSampO() {
      this.loadingFlag = true;
      this.searchSampForm.page_no = 1;
      (this.searchSampForm.smpl_no = null), (this.searchSampForm.smpl_name = null);
      if (this.isDyj) {
        this.searchSampForm.belo_dept_id = this.beloDeptId;
      } else {
        this.searchSampForm.belo_dept_id = null;
        this.$refs.selectSectionType.value2 = '全部';
      }
      this.getSampList();
    },
    submit() {
      const form = cloneDeep(this.openForm);
      form.lase_status = this.openForm.lase_status - 0;
      form.handCut_status = this.openForm.handCut_status - 0;
      form.stpr_status = this.openForm.stpr_status - 0;
      form.comp_status = this.openForm.comp_status - 0;
      form.embr_status = this.openForm.embr_status - 0;
      form.mase_status = this.openForm.mase_status - 0;
      form.manu_status = this.openForm.manu_status - 0;
      form.insp_status = this.openForm.insp_status - 0;
      form.stam_status = this.openForm.stam_status - 0;
      form.open_status = this.openForm.open_status - 0;
      form.emcd_status = this.openForm.emcd_status - 0;
      form.typesetting_status = this.openForm.typesetting_status - 0;

      if (!this.openForm.rfid_no) {
        return this.$message.warning('Rfid不可为空');
      }
      if (!this.openForm.smpl_id) {
        return this.$message.warning('样品编号不可为空');
      }
      if (!this.openForm.requ_id) {
        return this.$message.warning('委托编号不可为空');
      }
      this.$confirm('是否开卡?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })

        .then(() => {
          post(rfidAPI.open_card, form).then(res => {
            if (res.data.code !== 0) {
              return this.$message.error(res.data.msg);
            }
            this.$message.success(res.data.msg);
            this.jump(`/open_edit?rfid_id=${res.data.data.form_id}`);
            this.$refs.formRef.resetFields();
          });
        })
        .catch(() => {});
    },
    cancel() {
      this.$confirm('取消开卡, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.jump('open_list');
        })
        .catch(() => {});
    },
    emptyChange() {
      this.openForm.rfid_no = '';
      this.$nextTick(() => {
        this.$refs.cardRef.focus();
      });
    },
    //跳入样品总控
    gosmpl() {
      this.jump(`smpl_list?perm_id=${this.helper.retPermId('smpl')}`);
    },
    //查询范围
    getStatusVal2(val) {
      this.searchSampForm.belo_dept_id = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 10px;
}
.FormCl {
  width: 70%;
  margin: 0 auto;
}
</style>
